import { AboutContainer, InfoContainer, StyledImage } from './About.style';

import codingSvg from '../../assets/coding.svg';

const About = () => {
  return (
    <AboutContainer wrap="wrap">
      <StyledImage src={codingSvg} />
      <div>
        <h1>
          About Software Developer <span>Umit Arat</span>
        </h1>
      </div>
      <InfoContainer>
        <h2>Hi, I'am Umit</h2>
        <h3>I’m currently learning Full-Stack Development Languages.</h3>
        <h4>
          I've already known JS, ReactJS, NodeJS, PostgresqlDB, SQL,
          Python, Django.
        </h4>
        <h2>
          <a href="mailto:umitarat8098h@gmail.com">Send email</a> :
          umitarat8098@gmail.com
        </h2>
      </InfoContainer>
    </AboutContainer>
  );
};

export default About;
